<template>
    <v-container fluid grid-list-sm>
        <v-layout>
            <v-flex><h1 class="display-2">Gestión de etiquetas</h1></v-flex>
        </v-layout>
        <v-layout>
            <v-flex v-if="mostrarEmpresa">
                <empresa-select v-model="empresa_id" :filtro="empresas" @input="opMostrar"></empresa-select>
            </v-flex>
            <v-flex>
                <v-select :items="tiposImpr" v-model="tipoImpr" label="Seleccione tipo de impresion"></v-select>
            </v-flex>
            <v-flex>
                <v-btn color="primary" @click.native="mostrarSeleccion = !mostrarSeleccion">Solo mostrar seleccion</v-btn>
                <v-btn color="secondary" @click.native="generar()">Generar Etiqueta</v-btn>
            </v-flex>
        </v-layout>
        <v-layout column>
            <v-flex>
                <v-data-table :headers="opHeaders" :items="opItems" :loading="opLoading"
                              hide-actions
                              item-key="id"
                              select-all
                              v-model="seleccion"
                >
                    <template slot="items" slot-scope="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected"
                            v-if="(!mostrarSeleccion)? true : props.selected">
                            <td>
                                <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                            </td>
                            <td>{{ props.item.A1_NOME }}</td>
                            <td>{{ props.item.C2_OBS }}</td>
                            <td class="text-xs-center">{{ props.item.C2_NUM }}</td>
                            <td>{{ props.item.B1_DESC }}</td>
                            <td class="text-xs-right">{{ props.item.LARGO | decimales}}</td>
                            <td class="text-xs-right">{{ props.item.C2_LARGPZA | decimales}}</td>
                            <td class="text-xs-right">
                                {{ props.item.PIEZAS | decimales}}
                                <v-menu :close-on-content-click="false">
                                    <v-btn flat icon slot="activator">
                                        <v-icon color="green" size="16">edit</v-icon>
                                    </v-btn>
                                    <v-card>
                                        <v-card-text>
                                            <v-text-field v-model="props.item.PIEZAS" label="Nueva cantidad"></v-text-field>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </td>
                        </tr>
                    </template>
                    <template slot="footer">
                        <td colspan="100%" class="text-xs-right">
                            <strong>Total de piezas: {{ total }}</strong>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <errores v-model="msj.mostrar" :datos="msj"></errores>
    </v-container>
</template>

<script>
    import errores from '../../components/Errores';
    import empresaSelect from '../../components/EmpresaSelect.vue';
    import mixinUsers from '../../mixins/auth/users';
    import mixinPcp from '../../mixins/pcp';
    import decimales from '../../filters/decimales'

    export default {
        name: "etiquetas",
        components: {empresaSelect, errores},
        mixins: [mixinUsers, mixinPcp],
        filters: {decimales},
        data() {
            return {
                loading: false,
                opLoading: false,
                mostrarEmpresa: false,
                empresas: [],
                empresa_id: '',
                seleccion: [],
                mostrarSeleccion: false,
                tipoImpr: '',
                tiposImpr: [
                    {text: 'PDF', value: 'pdf'},
                    {text: 'ZEBRA', value: 'zebra'},
                ],
                msj: {
                    mostrar: false,
                    txt: '',
                    tipo: ''
                },
                opHeaders: [
                    {text: 'Cliente', value: 'A1_NOME', align: 'center'},
                    {text: 'Obs', value: 'C2_OBS', align: 'center'},
                    {text: 'Orden', value: 'C2_NUM', align: 'center'},
                    {text: 'Producto', value: 'B1_DESC', align: 'center'},
                    {text: 'Largo', value: 'LARGO', align: 'center'},
                    {text: 'Largo Pza', value: 'C2_LARGPZA', align: 'center'},
                    {text: 'Cant Piezas', value: 'PIEZAS', align: 'center'},
                ],
                opItems: [],
            }
        },
        computed: {
            total() {
                if (this.seleccion == null) {
                    return 0;
                }
                let tot = this.seleccion.reduce(function (a, b) {
                    return parseFloat(b.PIEZAS) == null ? parseFloat(a) : parseFloat(a) + parseFloat(b.PIEZAS);
                }, 0);
                return Intl.NumberFormat('es-AR').format(tot);
            }
        },
        mounted() {
            this.getUserEmpresas(r => {
                if (r.length > 1) {
                    this.mostrarEmpresa = true;
                    this.empresas = r;
                } else {
                    this.empresa_id = r[0];
                    if (!this.empresa_id) {
                        this.msj = {mostrar: true, txt: 'Usuario sin empresa asignada', tipo: 'error'};
                        return false
                    }
                    this.opMostrar();
                    this.mostrarEmpresa = false;
                }
            });
        },
        methods: {
            opMostrar() {
                this.opLoading = true;
                this.pcpLista({empresa_id: this.empresa_id}, r => {
                    this.opItems = r;
                    this.opLoading = false;
                }, err => {
                    console.log(err);
                    this.opLoading = false;
                })
            },
            generar() {
                if (!this.empresa_id) {
                    this.msj = {mostrar: true, txt: 'Debe seleccionar empresa', tipo: 'error'}
                    return false;
                }
                if (this.seleccion.length === 0) {
                    this.msj = {mostrar: true, txt: 'Debe seleccionar al menos un item', tipo: 'error'};
                    return false;
                }
                this.pcpGeneraPaca({datos: this.seleccion, empresa_id: this.empresa_id}, r => {
                    if (r.tipo === 'ok') {
                        window.open("pcp/etiqueta?id=" + r.p.id + "&tipo=" + this.tipoImpr, "_blank")
                    }
                    this.msj = r;
                }, err => {
                    console.log(err)
                })

            }
        }
    }
</script>

<style scoped>
    table.table tbody td {
        padding: 0 !important;
        height: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/pcp/etiquetas.vue